import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {JourneyService} from '../../service/journey.service';
import {Platform} from '@ionic/angular';
import {NavService} from '../../../../services/nav.service';
import {AnalyticsService} from '../../../../services/analytics.service';
import {TasksModel} from '../../../tasks/models/tasks.model';
import {UserService} from '../../../../services/user.service';
import {RequesterServerService} from '../../../../services/requester-server.service';

@Component({
    selector: 'app-journey-list-template-upload',
    templateUrl: './list-template-upload.component.html',
    styleUrls: ['./list-template-upload.component.scss']
})
export class LearningJourneyListTemplateUploadComponent implements OnInit {

    isLoadedFile = false;
    isFileSelected = false;
    isConfirmOpened = false;

    isShowProgress = false;
    progressValue = null;
    progressTitle = null;
    progressColor = null;

    @Input() embedded = false;
    @Input() currentStage: number;
    @Input() task: TasksModel = null;

    @ViewChild('file', {static: false}) file;
    @ViewChild('fileLabel', {static: false}) fileLabel;

    constructor(
        private journeyService: JourneyService,
        private userService: UserService,
        private requesterServerService: RequesterServerService,
        private platform: Platform,
        private linkSystem: NavService,
        private analytics: AnalyticsService,
        private sanitizer: DomSanitizer
    ) {
    }

    ngOnInit() {
        if (!!this.task.details.file.url) {
            this.isLoadedFile = true;
        } else {
            this.isLoadedFile = false;
        }
    }

    getProgressValue(color: string, percent: number) {
        return 'linear-gradient(to right, '
            + color + ' 0%, '
            + color + ' '
            + percent + '%, #ffffff '
            + percent + '%, #ffffff 100%)';
    }

    upload() {
        if (!this.isFileSelected) {
            return false;
        }
        this.showProgress(0, '#318cfd', '__JOURNEY_FILE_UPLOADING__');
        const self = this;
        if (this.isLoadedFile) {
            return false;
        }
        const file = this.file.nativeElement.files[0];
        const xhr = new XMLHttpRequest();

        // обработчик для отправки
        xhr.upload.onprogress = (event) => {
            const percent = Math.ceil((event.loaded / event.total) * 100);
            this.showProgress(percent);
        };

        // обработчики успеха и ошибки
        // если status == 200, то это успех, иначе ошибка
        xhr.onload = xhr.onerror = function() {
            if (this.status === 200) {
                self.isFileSelected = false;
                self.reloadStageData();
            } else {
                self.showProgress(100, '#FF0000', '__JOURNEY_FILE_UPLOAD_ERROR__');
            }
            setTimeout(_ => {
               self.hideProgress();
            }, 5000);
        };

        xhr.onreadystatechange = function() {
            if (this.readyState !== 4) {
                return;
            }
            try {
                const resp = JSON.parse(this.responseText);
                if (!!resp.error.isError) {
                    self.showProgress(100, '#FF0000', resp.error.message);
                } else {
                    self.showProgress(100, '#0BA700', resp.result.message);
                }
            } catch (e) {
                self.showProgress(100, '#FF0000', '__JOURNEY_FILE_UPLOAD_ERROR__');
            }
        };

        const formData = new FormData();
        formData.append('file', file);
        formData.append('section_id', this.task.details.file.section_id.toString(10));
        formData.append('del_id', this.task.details.file.del_id.toString(10));

        this.requesterServerService.customRequest(xhr, 'POST', 'uploadMyJourneyFile', formData);
    }

    openConfirmDialog() {
        if (this.isLoadedFile) {
            this.isConfirmOpened = true;
        }
    }

    delete(status) {
        this.isConfirmOpened = false;
        if (!this.isLoadedFile || !status) {
            return false;
        }
        this.showProgress(80, '#318cfd', '__JOURNEY_FILE_DELETING__');
        this.journeyService.deleteMyJourneyFile(this.task.details.file.section_id, this.task.details.file.del_id)
            .then(result => {
                this.reloadStageData();
                this.showProgress(100, '#FF0000', result.message);

                setTimeout(_ => {
                   this.hideProgress();
                }, 5000);
            });
    }

    fileOpen() {
        this.platform.ready().then((platform) => {
            this.linkSystem.toLink(this.task.details.file.url);
        });
    }

    fileChange(event) {
        this.fileLabel.nativeElement.innerHTML = this.file.nativeElement.files[0].name;
        this.isFileSelected = true;
    }

    private showProgress(percent: number, color: string = null, title: string = null) {
        if (title !== null) {
            this.progressTitle = title;
        }
        if (!!color) {
            this.progressColor = color;
        }
        this.progressValue = this.sanitizer.bypassSecurityTrustStyle(this.getProgressValue(this.progressColor, percent));
        this.isShowProgress = true;
    }

    private hideProgress() {
        this.isShowProgress = false;
    }

    private reloadStageData() {
        this.journeyService.getPageData(this.currentStage, this.userService.userTemplateId)
            .then(data => {
                if (!!data) {
                    this.task = data.details.list.find(item => item.id === this.task.id);
                    if (!!this.task.details.file.url) {
                        this.isLoadedFile = true;
                    } else {
                        this.isLoadedFile = false;
                    }
                }
            });
    }

}
